// Рецепты, для которых доступен калькулятор
export const CALCULATOR_RECIPE_IDS = new Set([
  650, // Торт «ФИСТАШКА-МАЛИНА»
  655, // Торт «ТРОПИЧЕСКИЙ»
  709, // Торт «ЧЕРНЫЙ ЛЕС»
  707, // Торт «СНИКЕРС»
  660, // Торт «ВАНИЛЬ-ЯГОДЫ»
  631, // Торт «НУТЕЛЛА»
  606, // Торт «МЕДОВИК»
  622, // Торт «БАНАНОВЫЙ»
  890, // ТОРТ «ИМБИРНЫЙ ПРЯНИК»
  549, // Торт «МОЛОЧНАЯ ДЕВОЧКА»
  857, // Торт «КОКОС-ВИШНЯ»
  858, // Торт «ЛАВАНДА-ЛИМОН-СМОРОДИНА»
  859, // Торт «КОФЕ-ФУНДУК»
  860, // Торт «ТРЮФЕЛЬ»
  626, // Торт «ФРЕЗЬЕ»
  643, // Торт «МОРКОВНЫЙ С КАРАМЕЛЬЮ»
  670, // Торт в форме тыквы «ПРЯНАЯ ГРУША»
  729, // Торт «ЭСТЕРХАЗИ»
  730, // Торт «ПРАГА»
  731, // Торт «ПТИЧЬЕ МОЛОКО»
  768, // Торт «МОЛОЧНЫЙ ЛОМТИК»
  769, // Торт «РАФАЭЛЛО»
  770, // Торт «ОРЕО»
  771, // Торт «ФЕРРЕРО»
  792, // Торт «СМЕТАННИК»
])
